import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';
import { API_KEY_FIELDS, mutateApiKeys } from './useGetApiKeys';

// Sets revoked_at; revoking a revoked key is a no-op.
export const REVOKE_API_KEY = gql`
  mutation RevokeApiKey($id: Int!) {
    revokeApiKey(id: $id) {
      ...apiKeyFields
    }
  }
  ${API_KEY_FIELDS}
`;

// revokeApiKey(id) resolves { success: true, data: apiKey } or
// { success: false, error }, and refetches this account's keys.
export function useRevokeApiKey(accountId) {
  const [mutate, { loading }] = useMutation(REVOKE_API_KEY);
  const revokeApiKey = useCallback(
    (id) => mutateApiKeys(mutate, accountId, { id }, 'revokeApiKey'),
    [mutate, accountId]
  );
  return { revokeApiKey, loading };
}
